import React, { useContext, useEffect } from 'react';
import { LanguageContext } from '../contexts/LanguageContext';
import './About.css';

const About = () => {
  const { language } = useContext(LanguageContext);

  const content = {
    ar: {
      title: 'عن المنظمة',
      description:
        'منظمة الخلد للإعمار والتنمية تأسست في يناير 2011، وهي منظمة خيرية تطوعية تعمل في مجالات الإعمار والتنمية البشرية والعمل الإنساني.',
      vision: 'رؤية المنظمة',
      visionDetails:
        'تسعى المنظمة لتعزيز العمل الاجتماعي والتكافل لتحقيق رفاهية الإنسان وضمان استدامة التنمية.',
      branches: 'فروع المنظمة',
      branchList: [
        'فرع ولاية جنوب دارفور',
        'فرع ولاية النيل الأبيض',
        'فرع ولاية الجزيرة',
        'فرع ولاية كسلا',
      ],
      mission: 'رسالة المنظمة',
      missionDetails:
        'تقديم الدعم والرعاية للفئات الأكثر حاجة في المجتمع مع العمل على تحقيق التنمية المستدامة من خلال مشروعات طويلة الأمد.',
      values: 'قيم المنظمة',
      valueList: [
        'الإنسانية: تقديم الدعم للجميع بغض النظر عن العرق أو الدين.',
        'الشفافية: العمل بمصداقية ووضوح.',
        'الاستدامة: تحقيق التنمية المستدامة في كافة المشاريع.',
      ],
    },
    en: {
      title: 'About the Organization',
      description:
        'Alkhold Organization for Development was established in January 2011. It is a charitable organization focusing on development, humanitarian aid, and providing essential services to those in need.',
      vision: 'Organization Vision',
      visionDetails:
        'The organization strives to promote social work and solidarity to ensure human well-being and sustainable development.',
      branches: 'Organization Branches',
      branchList: [
        'South Darfur Branch',
        'White Nile Branch',
        'Gezira Branch',
        'Kassala Branch',
      ],
      mission: 'Organization Mission',
      missionDetails:
        'To provide support and care for the most vulnerable groups in society while working towards sustainable development through long-term projects.',
      values: 'Organization Values',
      valueList: [
        'Humanity: Providing support regardless of race or religion.',
        'Transparency: Working with credibility and clarity.',
        'Sustainability: Achieving sustainable development in all projects.',
      ],
    },
  };

  const langContent = content[language];

  useEffect(() => {
    if (language === 'ar') {
      document.body.classList.add('rtl');
      document.body.classList.remove('ltr');
    } else {
      document.body.classList.add('ltr');
      document.body.classList.remove('rtl');
    }
  }, [language]);

  return (
    <div className="about">
      <h2>{langContent.title}</h2>
      <p>{langContent.description}</p>
      <h3>{langContent.vision}</h3>
      <p>{langContent.visionDetails}</p>
      <h3>{langContent.branches}</h3>
      <ul>
        {langContent.branchList.map((branch, index) => (
          <li key={index}>{branch}</li>
        ))}
      </ul>
      <h3>{langContent.mission}</h3>
      <p>{langContent.missionDetails}</p>
      <h3>{langContent.values}</h3>
      <ul>
        {langContent.valueList.map((value, index) => (
          <li key={index}>{value}</li>
        ))}
      </ul>
    </div>
  );
};

export default About;
